import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useAppSelector } from 'src/utils/Hooks';

const allClientRetailersSelector = createSelector(
  (state) => ({
    availableRetailers: state.retailer.availableRetailers,
    allRetailerIds: state.user.config.allRetailerIds
  }),
  ({ availableRetailers, allRetailerIds }) => {
    const availableRetailersMap = availableRetailers.reduce(
      (acc, retailer) => {
        acc[retailer.id] = retailer;
        return acc;
      }, {})

    return allRetailerIds.map((id) => availableRetailersMap[id])
      .filter((r) => !!r?.currencyCode)
  }
)

export const useGetCurrencies = () => {
  const allClientRetailers = useAppSelector(allClientRetailersSelector);

  const currencies = useMemo(() => {
    const currencies = new Set(['USD', ...allClientRetailers.map(r => r.currencyCode)]);

    return Array.from(currencies).map((currencyCode) => {
      const currencyName = new Intl.DisplayNames(['en'], {
        type: 'currency',
        style: 'long'
      }).of(currencyCode);

      return { id: currencyCode, name: currencyName };
    });
  }, [allClientRetailers]);

  return currencies;
};
